<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Expand1`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 4C4.22386 4 4 4.22386 4 4.5V19.5C4 19.7762 4.22385 20 4.5 20H19.5C19.7762 20 20 19.7762 20 19.5V4.5C20 4.22385 19.7762 4 19.5 4H4.5ZM2 4.5C2 3.11929 3.11929 2 4.5 2H19.5C20.8807 2 22 3.1193 22 4.5V19.5C22 20.8807 20.8807 22 19.5 22H4.5C3.1193 22 2 20.8807 2 19.5V4.5Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16 2C16.5523 2 17 2.44772 17 3V21C17 21.5523 16.5523 22 16 22 15.4477 22 15 21.5523 15 21V3C15 2.44772 15.4477 2 16 2zM7.29289 9.29289C7.68342 8.90237 8.31658 8.90237 8.70711 9.29289L10.7071 11.2929C11.0976 11.6834 11.0976 12.3166 10.7071 12.7071L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976 7.29289 14.7071 6.90237 14.3166 6.90237 13.6834 7.29289 13.2929L8.58579 12 7.29289 10.7071C6.90237 10.3166 6.90237 9.68342 7.29289 9.29289z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12 3C12 2.44772 12.4477 2 13 2H19C19.5523 2 20 2.44772 20 3 20 3.55228 19.5523 4 19 4H13C12.4477 4 12 3.55228 12 3zM12 21C12 20.4477 12.4477 20 13 20H19C19.5523 20 20 20.4477 20 21 20 21.5523 19.5523 22 19 22H13C12.4477 22 12 21.5523 12 21z"/></svg>
</template>
<script>

export default {
  name: 'IconExpand1',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
